import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './app/store';
import App from './App';
import ErrorBoundary from './app/layouts/ErrorBound';
import { LivekitRuntimeProvider } from './app/sdk/livekit';
import ToastProvider from "react-toaster-minimal";
import Container from '@material-ui/core/Container';
import L from 'leaflet';

// Fix Leaflet marker drift/jumping during map zoom animation by buffering coordinate updates
const originalSetLatLng = L.Marker.prototype.setLatLng;
const originalUpdate = L.Marker.prototype.update;

L.Marker.prototype.setLatLng = function (latlng) {
  if (this._map && (this._map._animatingZoom || this._map._zooming)) {
    this._zoomingLatLng = L.latLng(latlng);
    return this;
  }
  this._zoomingLatLng = null;
  return originalSetLatLng.call(this, latlng);
};

L.Marker.prototype.update = function () {
  if (this._map && (this._map._animatingZoom || this._map._zooming)) {
    return this;
  }
  if (this._zoomingLatLng) {
    const latlng = this._zoomingLatLng;
    this._zoomingLatLng = null;
    this.setLatLng(latlng);
    return this;
  }
  return originalUpdate.apply(this, arguments);
};

// Fix Leaflet Tooltip/Popup (DivOverlay) drift/jumping during map zoom animation
const originalDivOverlayUpdate = L.DivOverlay.prototype.update;
L.DivOverlay.prototype.update = function () {
  if (this._map && (this._map._animatingZoom || this._map._zooming)) {
    return this;
  }
  return originalDivOverlayUpdate.apply(this, arguments);
};

const originalDivOverlayUpdatePosition = L.DivOverlay.prototype._updatePosition;
L.DivOverlay.prototype._updatePosition = function () {
  if (this._map && (this._map._animatingZoom || this._map._zooming)) {
    return;
  }
  return originalDivOverlayUpdatePosition.apply(this, arguments);
};

ReactDOM.render((
  <Provider store={store}>
    <BrowserRouter>
      <LivekitRuntimeProvider>
      <ErrorBoundary>
      <ToastProvider>
        <Container disableGutters={true} maxWidth={false} style={{ height: '100vh'}}>
          <App />
        </Container>
      </ToastProvider>
      </ErrorBoundary>
      </LivekitRuntimeProvider>
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));

serviceWorker.unregister();
